import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import get from 'lodash.get'
import OpalCard from '../../opal/OpalCard'
import { useRSSFeedContext } from './RSSFeedContext'
import { fieldConfigPropType } from './RSSFeedItem/propTypes'

function RSSFeedInfo ({
  title: _title = { accessor: 'title' },
  description: _description = { accessor: 'description' },
  image: _image = { accessor: 'image' },
  link: _link = { accessor: 'link', text: 'Visit feed source' },
  className,
  style
}) {
  const { feed } = useRSSFeedContext()

  const normalizeConfig = (config) => {
    if (!config?.accessor) return null
    return {
      accessor: config?.accessor,
      className: config?.className || '',
      style: config?.style || {},
      text: config?.text,
      value: get(feed, config.accessor)
    }
  }

  const title = normalizeConfig(_title)
  const description = normalizeConfig(_description)
  const image = normalizeConfig(_image)
  const link = normalizeConfig(_link)

  if (!feed) return null

  return (
    <OpalCard className={clsx('p-4 mb-4', className)} style={style}>
      <div className='flex gap-5 center'>
        {image.value && (
          <div>
            <img
              src={image.value}
              alt={title.value}
              className={clsx(image.className)}
              style={image.style}
            />
          </div>
        )}
        <div className='flex-1'>
          {title.value && (
            <h2 className={clsx('font-size-xl font-weight-600 m-0 mb-2', title.className)} style={title.style}>
              {title.value}
            </h2>
          )}
          {description.value && (
            <p className={clsx('font-size-sm text-secondary m-0 mb-2', description.className)} style={description.style}>
              {description.value}
            </p>
          )}
          {link.value && (
            <a
              href={link.value}
              target='_blank'
              rel='noopener noreferrer'
              className={clsx('opal-link font-size-sm', link.className)}
              style={link.style}
            >
              {link.label || 'Visit feed source'}
            </a>
          )}
        </div>
      </div>
    </OpalCard>
  )
}

RSSFeedInfo.propTypes = {
  title: fieldConfigPropType,
  description: fieldConfigPropType,
  image: fieldConfigPropType,
  link: fieldConfigPropType,
  className: PropTypes.string,
  style: PropTypes.object
}

export default RSSFeedInfo
